import { render, staticRenderFns } from "./SignupProfessionalRequestSend.vue?vue&type=template&id=28e00404"
import script from "./SignupProfessionalRequestSend.vue?vue&type=script&lang=js"
export * from "./SignupProfessionalRequestSend.vue?vue&type=script&lang=js"
import style0 from "./SignupProfessionalRequestSend.vue?vue&type=style&index=0&id=28e00404&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports